import { render, staticRenderFns } from "./answer.vue?vue&type=template&id=5b19ca40&scoped=true&"
import script from "./answer.vue?vue&type=script&lang=js&"
export * from "./answer.vue?vue&type=script&lang=js&"
import style0 from "./answer.vue?vue&type=style&index=0&id=5b19ca40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b19ca40",
  null
  
)

export default component.exports